import React from 'react';
import SelectCore from "./SelectCore";
import { FormControl } from '~/native-ui/FormControl';
import { HStack } from 'native-base';
import { alignItems } from 'styled-system';

export class InlineSelect extends SelectCore {
    errorStyle = { color: 'danger.900' };

    get filteredSource() {
        return [
            ...this.getSelections().filter(Boolean),
            ...super.filteredSource
        ];
    }

    componentDidMount() {
        super.componentDidMount?.();
        this.props.onClick?.();
    }

    /**
     * 
     * @param {import('./SelectCore').SourceRecordObject} item 
     * 
     */
    existsInSelection = (item) => {
        const valueKey = this.props.valueKey;
        return !!this.getSelections().find((selection) => selection && selection[valueKey] === item[valueKey])
    }

    /**
     * 
     * @param {unknown} val 
     * @returns 
     */
    isSelectedValue = (val) => {
        return [this.props.value].flat().includes(val);
    }

    handleReorderItems (oldIndex, newIndex) {
        const firstSelectedItem = this.getSelections(true)[0][this.props.valueKey];
        const indexOffset = this.getOptions().findIndex((option) => option.value === firstSelectedItem);
        if (indexOffset < 0) return;

        oldIndex = oldIndex - indexOffset;
        newIndex = Math.max(0, newIndex - indexOffset);
        super.handleReorderItems(oldIndex, newIndex)
    };

    renderOptionIcons(item) {
        return null;
    }

    renderOptionLabel(item, index, query) {
        const label = super.renderOptionLabel(item, index, query);
        const selectedOptionIcon = super.renderOptionIcons(item);

        const selectionIcon = this.existsInSelection(item)
            && this.renderIcons(item, index, {
                iconRemove: selectedOptionIcon,
                isLoading: false,
                canEdit: true,
                iconProps: { p: '0', marginBottom: -1, size: 5, iconProps: {size: 5, } },
                triggerSelectOnIconClick: false,
                wrapperProps: {  ml: 'auto', alignItems: 'center', justifyContent: 'center', space: 1 },
            });

        const rightSideIcon = this.renderIcons(item, index, {
            iconRemove: !this.props.multiSelect ? 'radio-button-unchecked' : 'check-box-outline-blank',
            iconNotEmpty: !this.props.multiSelect ? 'radio-button-unchecked' : 'check-box-outline-blank',
            isLoading: false,
            orderable: false,
            canEdit: false,
            triggerSelectOnIconClick: false,
            iconProps: { p: '0', marginBottom: -1, iconProps: {size: 5, }, colorScheme: "muted", pointerEvents: "none" },
            wrapperProps: {  ml: 'auto', alignItems: 'center', justifyContent: 'center', space: 1 },
        })

        const emptyBullet = <HStack width={21} height={21} />

        return ({ isHovered }) => (
            <>
                { label }
                { selectionIcon }
                { !selectionIcon && isHovered && rightSideIcon }
                { !selectionIcon && !isHovered && emptyBullet }
            </>
        )
    }

    renderItem (arg, ...rest) {
        return this.maybeOrderableListItem({
            index: arg.index,
            orderable: this.props.orderable && !!arg.item && this.isSelectedValue(arg.item[this.props.valueKey]),
            children: super.renderItem(arg, ...rest),
        })
    }


    normalizeValueOnSelect (val) {
        const isSelected = this.isSelectedValue(val);

        if (this.props.multiSelect) {
            val = isSelected ? this.props.value.filter((selection) => selection !== val) : [...this.props.value, val];
            val = val.filter((v) => typeof v !== 'undefined');
        }

        return val;
    }

    render() {
        const [nbProps,dropdownProps] = this.extractProps();
        const {
            allowBlank,
            auto,
            labelKey,
            required,
            onChange,
            onFocus,
            onBlur, // eslint-disable-line no-unused-vars
            source,
            template,
            theme,
            minCharacters,
            multiSelect,
            minQueryLength,
            loading,
            filterHint,
            allowFiltering,
            onQueryChange,
            query,
            small,
            valueKey,
            templateValueClassName,
            selectedOptionClassName,
            optionClassName,
            label,
            tooltip,
            disabled,
            error,
            isReadOnly,
            isinvalid,
            ...others
        } = dropdownProps;

        return (
            <FormControl
                mt={!isReadOnly ? 'auto' : undefined}
                {...nbProps}
                isRequired={required}
                isDisabled={disabled}
                isInvalid={isinvalid}
                flex={1}
            >
                {!error && label && <FormControl.Label key="label" label={label} tooltip={tooltip} />}
                {error && <FormControl.Label key="label" {...this.errorStyle} label={error} tooltip={tooltip} />}

                {this.props.allowFiltering && this.renderFilterInput()}
                {this.renderOptions({ orderable: true })}
            </FormControl>
        );
    }
}

export default InlineSelect;